import {
  Blockquote,
  Button,
  ButtonGroup,
  Group,
  Stack,
  Title,
  Text,
  Container,
} from "@mantine/core";
import { useNavigate, useParams } from "react-router";
import { trackEvent } from "../analytics.ts";

export const Danke = () => {
  const navigate = useNavigate();
  const params = useParams<"vortragId">();

  return (
    <Container size="md">
      <Stack>
        <Title order={2}>Vielen Dank für Ihre Anmeldung!</Title>
        <Blockquote color="green">
          Wir haben Ihre Anmeldung erhalten und Ihnen eine Bestätigung an die
          angegebene E-Mail-Adresse gesendet. Darin finden Sie nochmal alle
          Informationen zu Ihrer gewählten Veranstaltung.
        </Blockquote>
        <Group>
          <ButtonGroup>
            <Button
              type="submit"
              size="md"
              radius="xl"
              onClick={() => {
                trackEvent("weitere-person-anmelden", {
                  vortragId: params.vortragId ?? "",
                });
                navigate(`/anmelden/${params.vortragId}`);
              }}
            >
              Weitere Person zum Vortrag anmelden
            </Button>
          </ButtonGroup>
          <Text>
            <a href="#" onClick={() => navigate("/")}>
              Alle Vorträge anzeigen
            </a>
          </Text>
        </Group>
        <Text fw="bold" mt="xl">
          Wenn Sie nicht teilnehmen können, bitten wir um Abmeldung.
          Informationen dazu haben Sie per E-Mail erhalten.
        </Text>
        <Text>Bei Fragen stehen wir Ihnen jederzeit gerne zur Verfügung.</Text>
        <Text>Wir freuen uns auf Ihren Besuch!</Text>
      </Stack>
    </Container>
  );
};
